import { render, staticRenderFns } from "./volume-control.vue?vue&type=template&id=2fbd1972"
import script from "./volume-control.vue?vue&type=script&lang=js"
export * from "./volume-control.vue?vue&type=script&lang=js"
import style0 from "./volume-control.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports